import { useQuery } from "@tanstack/react-query";
import {
  searchLaunchables,
  type SearchLaunchablesRequest,
} from "./api";

// Launchable writes still use the legacy agent and cannot invalidate these
// resource keys yet. Keep reads immediately stale so repeated searches
// observe publish, edit, and access changes.
const launchableQueryStaleTimeMs = 0;

export const launchableKeys = {
  all: ["devplane", "launchables"] as const,
  searches: () => [...launchableKeys.all, "search"] as const,
  search: (request: SearchLaunchablesRequest) =>
    [...launchableKeys.searches(), request] as const,
};

export function launchableSearchQueryOptions(
  request: SearchLaunchablesRequest,
) {
  return {
    queryKey: launchableKeys.search(request),
    queryFn: () => searchLaunchables(request),
    staleTime: launchableQueryStaleTimeMs,
  };
}

export function useLaunchableSearchQuery(
  request: SearchLaunchablesRequest,
  enabled: boolean = true,
) {
  return useQuery({
    ...launchableSearchQueryOptions(request),
    enabled,
  });
}
